(function ($, global, GsBase) {
	'use strict';
	//현재 페이지 엔트리 JSON 데이터
	var entryData = GsBase.entryData = GsBase.entryData || $.parseJSON($('#entry-data').html());
}) (jQuery, window, window.GsBase = window.GsBase || {});

$(function(){
	
	var initParams = WinePrd.getParams();
	var msectid = GsBase.entryData.param.msectid == null ? 0 : GsBase.entryData.param.msectid;
	var ssectid = GsBase.entryData.param.ssectid == null ? 0 : GsBase.entryData.param.ssectid;
	if( document.location.hash ){
		WinePrd.handleHash();
		window.PageNavigationUtil.attachEvent(WinePrd.changeHash);
		setSmlSectBtn(initParams.ssectid);
	}else{
		initParams.searchType = 'SECT';
		initParams.sortType = 'DEFAULT';
		initParams.msectid = msectid;
		initParams.ssectid = ssectid;
		WinePrd.init();
	}	

	window.onhashchange = function locationHashChanged() {
	
		if( document.location.hash ){
			WinePrd.handleHash();
			var params = WinePrd.getParams();
			setSmlSectBtn(params.ssectid);
		} else {
			var params = WinePrd.getParams();
			params.msectid = GsBase.entryData.param.msectid==null?0:GsBase.entryData.param.msectid;
			params.ssectid = GsBase.entryData.param.ssectid==null?0:GsBase.entryData.param.ssectid;
			WinePrd.loadPrdList();
			setSmlSectBtn("");
		}
	};	
	
	$(".btn-sml-sect").click(function(e){
		e.preventDefault();
		var $this = $(this);
		var ssectid = $this.data("sectid");
		$this.parent().siblings().removeClass("on");
		$this.parent().addClass("on");
		window.PageNavigationUtil.pageIdx = 1;
		
		var params = WinePrd.getParams();
		params.ssectid = ssectid;
		
		var lseq = "424352-" + ssectid;
		LSeqUtil.clickLseqSend(lseq);	//효율코드 호출		
		
		WinePrd.changeHash();
	});

	// 랭킹 툴팁 띄우기 (단품쪽 툴팁과 별개임.)
	$("#rankingNotiTooltip").click(function(e) {
		e.stopPropagation();
		$(this).find('.prd_tip_img').toggleClass('on');
		$(this).find('.tip_green_t').toggleClass('displayNone');
	});

	$("input.btn-sort").click(function(e){
		e.preventDefault();
		e.stopPropagation();

		// 랭킹 툴팁 close
		if($('#rankingNotiTooltip .prd_tip_img').hasClass('on')) {
			$('#rankingNotiTooltip .tip_close').click();
		}

		//효율코드
		var lseq = "424355";
		var idx = $(this).data('idx');
		if(idx){
			lseq = lseq+"-"+idx
		}
		LSeqUtil.clickLseqSend(lseq);

		var params = WinePrd.getParams();
		params.sortType = $(this).val();
		window.PageNavigationUtil.pageIdx = 1;
		WinePrd.changeHash();
	});
	
});

function setSmlSectBtn(activeSectId){
	$(".btn-sml-sect").each(function(idx){
		var $this = $(this);
		if($this.data("sectid") == activeSectId){
			$this.parent().addClass("on");		
		}else{
			$this.parent().removeClass("on");
		}
	});
}